import React, { createContext, useState, useContext, useEffect } from 'react';
import { getStats, getTilePrefixes, getOrders, getYearStatistics, getLedBatchStatistics, getTileTypesInfo4 } from '../services/statsQueries';

const StatsContext = createContext();

export const StatsProvider = ({ children }) => {
  const [stats, setStats] = useState({});
  const [prefixData, setPrefixData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [yearData, setYearData] = useState([]);
  const [ledBatchData, setLedBatchData] = useState([]);
  const [tileTypesInfo4Data, setTileTypesInfo4Data] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let activeFetchCount = 6;  // Total number of fetch operations

    const fetchStats = async () => {
      // Use Supabase directly instead of API call
      const data = await getStats();
      setStats(data);
      activeFetchCount--;
      if (activeFetchCount === 0) setIsLoading(false);
    };

    const fetchPrefixData = async () => {
      // Use Supabase directly instead of API call
      const data = await getTilePrefixes();
      setPrefixData(data);
      activeFetchCount--;
      if (activeFetchCount === 0) setIsLoading(false);
    };

    const fetchOrderData = async () => {
      // Use Supabase directly instead of API call
      const data = await getOrders();
      setOrderData(data);
      activeFetchCount--;
      if (activeFetchCount === 0) setIsLoading(false);
    };

    const fetchYearData = async () => {
      // Use Supabase directly instead of API call
      const data = await getYearStatistics();
      setYearData(data);
      activeFetchCount--;
      if (activeFetchCount === 0) setIsLoading(false);
    };

    const fetchLedBatchData = async () => {
      // Use Supabase directly instead of API call
      const data = await getLedBatchStatistics();
      setLedBatchData(data);
      activeFetchCount--;
      if (activeFetchCount === 0) setIsLoading(false);
    };

    const fetchTileTypesInfo4Data = async () => {
      // Use Supabase directly instead of API call
      const data = await getTileTypesInfo4();
      setTileTypesInfo4Data(data);
      activeFetchCount--;
      if (activeFetchCount === 0) setIsLoading(false);
    };

    fetchStats();
    fetchPrefixData();
    fetchOrderData();
    fetchYearData();
    fetchLedBatchData();
    fetchTileTypesInfo4Data();
  }, []);

  return (
    <StatsContext.Provider value={{ stats, prefixData, orderData, yearData, ledBatchData, tileTypesInfo4Data, isLoading, setStats, setPrefixData, setOrderData, setYearData, setLedBatchData, setTileTypesInfo4Data, setIsLoading }}>
      {children}
    </StatsContext.Provider>
  );
};

// Custom hook to use stats
export const useStats = () => useContext(StatsContext);
